import { forwardRef, useCallback, useEffect, useImperativeHandle, useRef } from "react";

export const SignaturePad = forwardRef(function SignaturePad({ testId, onChange }, ref) {
  const canvas = useRef(null);
  const drawing = useRef(false);
  const empty = useRef(true);
  const last = useRef(null);

  const setup = useCallback(() => {
    const c = canvas.current;
    const dpr = Math.min(window.devicePixelRatio || 1, 2);
    const rect = c.getBoundingClientRect();
    c.width = rect.width * dpr;
    c.height = rect.height * dpr;
    const ctx = c.getContext("2d");
    ctx.scale(dpr, dpr);
    ctx.lineWidth = 2.2;
    ctx.lineCap = "round";
    ctx.lineJoin = "round";
    ctx.strokeStyle = "#14213d";
    empty.current = true;
  }, []);

  useEffect(() => {
    setup();
  }, [setup]);

  const pos = (e) => {
    const r = canvas.current.getBoundingClientRect();
    return { x: e.clientX - r.left, y: e.clientY - r.top };
  };
  const down = (e) => {
    e.preventDefault();
    canvas.current.setPointerCapture(e.pointerId);
    drawing.current = true;
    last.current = pos(e);
  };
  const move = (e) => {
    if (!drawing.current) return;
    const p = pos(e);
    const ctx = canvas.current.getContext("2d");
    ctx.beginPath();
    ctx.moveTo(last.current.x, last.current.y);
    ctx.lineTo(p.x, p.y);
    ctx.stroke();
    last.current = p;
    if (empty.current) {
      empty.current = false;
      onChange && onChange(false);
    }
  };
  const up = () => { drawing.current = false; };

  useImperativeHandle(ref, () => ({
    clear: () => { setup(); onChange && onChange(true); },
    isEmpty: () => empty.current,
    toDataURL: () => canvas.current.toDataURL("image/png"),
    fromDataURL: (url) => {
      setup();
      const img = new Image();
      img.onload = () => {
        const r = canvas.current.getBoundingClientRect();
        canvas.current.getContext("2d").drawImage(img, 0, 0, r.width, r.height);
        empty.current = false;
        onChange && onChange(false);
      };
      img.src = url;
    },
  }));

  return (
    <div className="relative rounded-lg border-2 border-dashed border-[#34B3B0] bg-white">
      <canvas
        ref={canvas}
        data-testid={testId}
        className="w-full h-44 sm:h-48 touch-none cursor-crosshair rounded-lg"
        onPointerDown={down}
        onPointerMove={move}
        onPointerUp={up}
        onPointerLeave={up}
      />
      <div className="pointer-events-none absolute left-4 right-4 bottom-10 border-b border-[#D4E6EC]" />
      <div className="pointer-events-none absolute left-4 bottom-3 text-[10px] uppercase tracking-widest text-[#A8C6CF]">Firmare qui</div>
    </div>
  );
});
